import google, { mutators, verify } from "@churchofjesuschrist/maps-google";
import { emptyNode, isString, proxy, removeUndefined, styleClass, toHTML } from "@churchofjesuschrist/maps-utils";
import { clear, toHTMLString } from "@churchofjesuschrist/eden-icons-raw";
let initialized = false;
const defaultOptions = {};
class Modal {
  constructor(options) {
    if (!initialized) {
      verify();
      construct();
      initialized = true;
    }
    this.setOptions({
      ...defaultOptions,
      ...removeUndefined(options)
    });
  }
}
const construct = () => {
  const overlayClass = styleClass("google-modal")`
        position: absolute;
        z-index: 1;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(32,33,36,.7);
        background-filter: blur(3px);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px;
        box-sizing: border-box;
    `;
  const dialogClass = styleClass("google-modal", "dialog")`
        background: #fff;
        border-radius: 8px;
        display: flex;
        flex: 0 0 auto;
        flex-direction: column;
        max-height: 100%;
        max-width: 100%;
        padding: 24px 8px 8px;
        position: relative;
    `;
  const headerClass = styleClass("google-modal", "header")`
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        padding: 0 16px;
    `;
  const titleClass = styleClass("google-modal", "title")`
        font-family: Google Sans,Roboto,Arial,sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: .00625em;
        color: #3c4043;
        margin: 0 16px 0 0;
    `;
  const closeClass = styleClass("google-modal", "close")`
        background: none;
        display: block;
        border: 0;
        margin: 0;
        padding: 0;
        appearance: none;
        position: static;
        cursor: pointer;
        user-select: none;
        top: 24px;
        right: 24px;
        width: 24px;
        height: 24px;
        font-size: 24px;
        color: #000;
        opacity: 0.6;
        &:hover, &:active {
            opacity: 1.0;
        }
    `;
  const contentClass = styleClass("google-modal", "content")`
        font-family: Roboto,Arial,sans-serif;
        font-size: 13px;
        padding: 0 16px 16px;
        overflow: auto;
    `;
  Object.setPrototypeOf(Modal.prototype, Object.assign(new google.maps.MVCObject(), mutators("title", "content", "map"), (() => {
    function onAdd() {
      let map = this.getMap();
      if (this.$map !== map) {
        onRemove.call(this);
        this.$map = map;
        updateContent.call(this);
      }
    }
    function onRemove() {
      if (this.$div) {
        this.$div.parentNode.removeChild(this.$div);
        delete this.$div;
      }
      delete this.$map;
    }
    function updateContent() {
      let mapDiv = this.getMap()?.getDiv(),
        content = this.getContent();
      if (mapDiv && content) {
        if (this.$div) {
          emptyNode(this.$div);
        } else {
          this.$div = document.createElement("div");
          this.$div.className = overlayClass;
        }
        let dialog = document.createElement("div");
        dialog.className = dialogClass;
        let header = document.createElement("div");
        header.className = headerClass;
        dialog.appendChild(header);
        let h2 = document.createElement("h2");
        h2.className = titleClass;
        h2.innerHTML = this.getTitle();
        header.appendChild(h2);
        let closeButton = document.createElement("button");
        closeButton.type = "button";
        closeButton.className = closeClass;
        closeButton.innerHTML = toHTMLString(clear);
        closeButton.addEventListener("click", proxy(onCloseClick, this));
        header.appendChild(closeButton);
        let contentDiv = document.createElement("div");
        contentDiv.className = contentClass;
        if (isString(content)) {
          content = toHTML(content);
        }
        contentDiv.appendChild(content);
        dialog.appendChild(contentDiv);
        this.$div.appendChild(dialog);
        mapDiv.appendChild(this.$div);
      }
    }
    function onCloseClick() {
      this.setMap(null);
    }
    return {
      changed: function (key) {
        switch (key) {
          case "map":
            if (this.getMap()) {
              onAdd.call(this);
            } else {
              onRemove.call(this);
            }
            break;
          case "title":
          case "content":
            updateContent.call(this);
            break;
        }
      }
    };
  })()));
};
export default Modal;